import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { generateSEOTags, applySEOTags, pageSEOConfig } from '../utils/seoUtils';

/**
 * SEO Head component that automatically applies SEO tags based on current route
 * Usage: <SEOHead pageType="home" customConfig={{title: "Custom Title"}} />
 */
const SEOHead = ({ 
  pageType = null, 
  customConfig = {},
  title = null,
  description = null,
  keywords = [],
  image = null 
}) => {
  const location = useLocation();
  
  useEffect(() => {
    // Determine page type from route if not provided
    let currentPageType = pageType;
    if (!currentPageType) {
      const path = location.pathname;
      if (path === '/') currentPageType = 'home';
      else if (path.startsWith('/blog')) currentPageType = 'blog';
      else if (path.startsWith('/docs')) currentPageType = 'docs';
      else if (path.startsWith('/download')) currentPageType = 'download';
      else if (path.startsWith('/tools')) currentPageType = 'tools';
      else if (path.startsWith('/about')) currentPageType = 'about';
      else if (path.startsWith('/contact')) currentPageType = 'contact';
      else currentPageType = 'home'; // fallback
    }
    
    // Get base config for this page type
    const baseConfig = pageSEOConfig[currentPageType] || pageSEOConfig.home;
    
    // Merge custom config
    const finalConfig = {
      ...baseConfig,
      ...customConfig,
      // Override with individual props if provided
      ...(title && { title }),
      ...(description && { description }),
      ...(keywords.length > 0 && { keywords }),
      ...(image && { image }),
    };
    
    // Generate and apply SEO tags
    const seoTags = generateSEOTags({
      title: finalConfig.title,
      description: finalConfig.description,
      keywords: finalConfig.keywords,
      image: finalConfig.image,
      url: window.location.href,
      type: currentPageType === 'blog' ? 'article' : 'website',
      author: 'Kief Studio',
      siteName: 'PWGen-Rust'
    });
    
    applySEOTags(seoTags);
    
    return () => {
      // Cleanup function if needed
    };
  }, [pageType, customConfig, title, description, keywords, image, location.pathname]);

  // This component doesn't render anything visible
  return null;
};

export default SEOHead;